module.exports = __webpack_public_path__ + "img/vrsc.1eafa231.svg";